/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section5_P1Inputs */

const en_terms_section5_p1 = /** @type {(inputs: Terms_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is open-source software. The source code is available on GitHub and is subject to its respective license. The PureJSON name, logo, and branding are the property of the project maintainers.`)
};

const ko_terms_section5_p1 = /** @type {(inputs: Terms_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 오픈 소스 소프트웨어입니다. 소스 코드는 GitHub에서 이용 가능하며 해당 라이선스의 적용을 받습니다. PureJSON 이름, 로고 및 브랜딩은 프로젝트 관리자의 재산입니다.`)
};

const ja_terms_section5_p1 = /** @type {(inputs: Terms_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはオープンソースソフトウェアです。ソースコードはGitHubで利用可能であり、それぞれのライセンスに従います。PureJSONの名称、ロゴ、ブランディングはプロジェクト管理者の財産です。`)
};

/**
* | output |
* | --- |
* | "PureJSON is open-source software. The source code is available on GitHub and is subject to its respective license. The PureJSON name, logo, and branding are ..." |
*
* @param {Terms_Section5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section5_p1 = /** @type {((inputs?: Terms_Section5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section5_p1(inputs)
	if (locale === "ko") return ko_terms_section5_p1(inputs)
	return ja_terms_section5_p1(inputs)
});